import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from "@material-ui/icons/Error";

const EmptyState = (props) => {
  const { text, icon } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {icon === "error" && (
        <ErrorIcon style={{ fontSize: 60 }} className={classes.icon} />
      )}
      <Typography variant="h6" color="textSecondary">
        {text}
      </Typography>
    </div>
  );
};

export default EmptyState;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "240px",
  },
  icon: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
}));
